<div class="flex gap-4">
  <dssa-sidebar>
    @for (group of groups(); track group.label) {
    <dssa-sidebar-group [label]="group.label">
      @for (item of group.items; track item.path) {
      <dssa-sidebar-menu-item
        [label]="item.label"
        [path]="item.path"
        [hasSubItems]="!!item.subItems"
        [isDisabled]="item.disabled ?? false"
        [isActive]="currentPath() === item.path"
      >
        <dssa-icon [icon]="item.icon!" [size]="18" [strokeWidth]="2" />
        @for (subItem of item.subItems; track subItem.path) {
        <dssa-sidebar-menu-sub-item [label]="subItem.label" [path]="subItem.path" />
        }
      </dssa-sidebar-menu-item>
      }
    </dssa-sidebar-group>
    }
  </dssa-sidebar>

  <main class="flex-1">
    <router-outlet />
  </main>
</div>
